module.exports = __webpack_public_path__ + "7d96074dfb818c87b8a73480562f612a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/data-to-make-you-better/screens/desktop/run.png
// module id = 1745
// module chunks = 1